import { useTranslation } from 'react-i18next';
import { Link, P } from '@vp/swan';
import { sanitiseLocale } from '../../i18n/config';
import LogoGallery from '../../pages/LogomakerGenAiPagePhase1/components/LogoGallery/LogoGallery';
import { useTrackNavigationClicked } from '../../utils/analytics';
import { isGenAiLogomakerAvailable } from '../../utils/featureAvailability';
import { logoInspirationBasePath } from '../../utils/urls';
import LogomakerAnywhere from '../LogomakerAnywhere/LogomakerAnywhere';
import DomainNames from './DomainNames';
import type { BusinessName } from '../../pages/BusinessNameGeneratorPage/components/BusinessNameResults/BusinessNameResults';

type BusinessNameDetailProps = {
    businessName: BusinessName;
    trackingEventDetails: {
        category: string;
    };
    keyword?: string;
    industryKeywords?: string[];
};

const BusinessNameDetail = ({
    businessName,
    trackingEventDetails,
    keyword,
    industryKeywords,
}: BusinessNameDetailProps) => {
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);
    const processedKeyword = keyword || industryKeywords?.[0] || '';
    const processedIndustryKeywords =
        keyword || !industryKeywords ? industryKeywords : industryKeywords?.slice(1);

    const logoIdeasRef = useTrackNavigationClicked(
        'LogomakerAnywhere',
        'LogomakerAnywhere',
        logoInspirationBasePath,
        'logoIdeas',
    );

    const description = (
        <>
            Try our free Logomaker and see your business name come to life in seconds. Don't know
            where to start? Get inspired with our range of{' '}
            <Link href={logoInspirationBasePath} target="_blank" ref={logoIdeasRef}>
                logo ideas
            </Link>
            .
        </>
    );

    return (
        <>
            <P>{businessName.description}</P>
            <DomainNames businessName={businessName} trackingEventDetails={trackingEventDetails} />
            {businessName.name &&
                (isGenAiLogomakerAvailable(locale) ? (
                    <LogoGallery isModalLayout />
                ) : (
                    <LogomakerAnywhere
                        description={description}
                        initialBusinessName={businessName.name}
                        keyword={processedKeyword}
                        industryKeywords={processedIndustryKeywords}
                        showBusinessNameInput={false}
                        isModalLayout
                    />
                ))}
        </>
    );
};

export default BusinessNameDetail;
